module.exports = __webpack_public_path__ + "public/img/Soto.999e9696.png";